const ABOUT_IMG =
  "https://radiantfr.com/wp-content/uploads/2025/07/WhatsApp-Image-2025-06-26-at-2.12.44-PM.jpeg";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#F9F5F0] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Image — asymmetric, offset */}
        <div className="lg:col-span-5 lg:col-start-1">
          <div className="relative">
            <div className="w-full overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Amber Rufer, mobile beauty specialist"
                className="block w-full h-auto"
              />
            </div>
            <div className="hidden lg:block absolute -bottom-6 -right-6 bg-[#FAEDE6] px-8 py-6 border-l border-[#B78782]/30">
              <p className="font-script text-[#B78782] text-3xl leading-none">
                Amber Rufer
              </p>
              <p className="mt-2 text-[10px] tracking-[0.32em] uppercase text-[#4A3737]/70">
                Mobile Beauty Specialist
              </p>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="lg:col-span-6 lg:col-start-7">
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-8 bg-[#B78782]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#B78782]">
              About
            </span>
          </div>
          <h2 className="font-serif-display text-[#4A3737] text-4xl md:text-5xl lg:text-[58px] font-light leading-[1.05] tracking-tight">
            A trusted ritual,
            <br />
            personally delivered.
          </h2>

          <div className="hairline my-10 max-w-sm" />

          <div className="space-y-6 text-[15px] md:text-base leading-relaxed text-[#4A3737]/85 font-light max-w-xl">
            <p>
              Amber is an expert beautician with a quiet, considered approach to
              skincare — turning your living room, bedroom or kitchen bench into
              a sanctuary tailored entirely to you.
            </p>
            <p>
              Every treatment is built around your skin's story: results-driven,
              never rushed, and always finished with the kind of warm,
              attentive care that turns first-time clients into long-time
              regulars across Auckland.
            </p>
            <p className="text-[#B78782] italic">
              "I bring the studio to your door — so the only thing left for you
              to do is exhale."
            </p>
          </div>

          <dl className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: "5+", v: "Years experience" },
              { k: "Auckland", v: "Wide service area" },
              { k: "100%", v: "At-home convenience" },
            ].map((s) => (
              <div key={s.v} className="border-t border-[#B78782]/30 pt-4">
                <dt className="font-serif-display text-[#4A3737] text-3xl md:text-4xl font-light">
                  {s.k}
                </dt>
                <dd className="mt-1 text-[10px] tracking-[0.24em] uppercase text-[#4A3737]/70">
                  {s.v}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
